import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/auth/AuthContext";
import React from "react";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { checkToken } = useAuth();

  return checkToken() ? children : <Navigate to="/login" />;
};
